import { getUserToken } from "../../../service/authorization"
import decorator from "../decorator/decorator"
import { SimulationInput } from "./SimulationInput"
import useSimulationInput from "./SimulationInput/useSimulationInput"
import validationSchema from "./SimulationInput/validator/validator"
import { setIn } from "final-form"
import arrayMutators from "final-form-arrays"
import createDecorator from "final-form-calculate"
import React, { useMemo, useRef } from "react"
import * as FinalForm from "react-final-form"
import { useParams } from "react-router-dom"

const focusOnErrors = createDecorator()

export function SimulationInputFormWrapper({ tunnelData, simulationSubmit, setProduct }) {
  const params = useParams()
  const formRef = useRef(null)
  const opl = params?.opl

  const { valuesFromOrder, setInitialValues } = useSimulationInput(opl)

  const token = useMemo(() => getUserToken(), [])

  const initialValues = {
    products: [{ quantity: "1" }],
    productCreationEnabled: formRef?.current?.productCreationEnabled,
    allowModifyProductPrice: formRef?.current?.allowModifyProductPrice
  }
  const initialFormValues = setInitialValues(initialValues, valuesFromOrder)

  const handleDecorator = React.useMemo(
    () => decorator(tunnelData, token),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const validateFormValues = (schema) => async (values) => {
    if (typeof schema === "function") {
      schema = schema()
    }
    try {
      await schema.validate(values, { abortEarly: false })
    } catch (err) {
      const errors = err.inner.reduce((formError, innerError) => {
        return setIn(formError, innerError.path, innerError.message)
      }, {})

      return errors
    }
  }

  const validate = validateFormValues(validationSchema)

  return (
    <FinalForm.Form
      decorators={[handleDecorator, focusOnErrors]}
      mutators={{
        ...arrayMutators
      }}
      validate={validate}
      initialValues={initialFormValues}
      onSubmit={simulationSubmit}
      keepDirtyOnReinitialize
      render={({
        form: {
          mutators: { push }
        },
        form,
        values,
        hasValidationErrors
      }) => {
        formRef.current = values

        return (
          <SimulationInput
            tunnelData={tunnelData}
            handleSubmit={simulationSubmit}
            setProduct={setProduct}
            values={values}
            form={form}
            push={push}
            hasValidationErrors={hasValidationErrors}
          />
        )
      }}
    />
  )
}
